import React, { Component } from 'react';
import Link from 'gatsby-link';
import LocaleSwitcher from './LocaleSwitcher';
//import Logo from '../svg/logo';
import logo from '../img/logo.png';

class MainNavigation extends Component {
  constructor(props) {
    super(props);
    const { locale, path } = props;
    this.state = { locale: props.locale, path: props.path, isActive: false };
  }

  componentDidMount() {
    if (typeof window !== `undefined`) {
      window.addEventListener('resize', this.onResize);
    }
    this.setActiveItem(null, this.props.path);
  }

  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  onResize = () => {
    if (this.state.isActive && window.innerWidth >= 768) {
      this.setState({ ...this.state, isActive: false });
    }
  };

  setActiveItem = (navItems = null, path) => {
    if (!navItems) {
      navItems = Array.from(
        document.querySelectorAll(
          '.navbar-end .navbar-item:not(.is-locale-switcher)'
        )
      );
    }
    navItems.forEach(item => {
      const link = item.querySelector('a');
      const slug = link.getAttribute('href');
      if (slug === path) {
        if (!item.classList.contains('is-active')) {
          item.classList.add('is-active');
        }
      } else {
        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      }
    });
  };

  componentWillReceiveProps(nextProps) {
    const navItems = Array.from(
      document.querySelectorAll(
        '.navbar-end .navbar-item:not(.is-locale-switcher)'
      )
    );
    this.setActiveItem(navItems, nextProps.path);
    if (this.props.locale === nextProps.locale) {
      if (this.state.locale === undefined) {
        this.setState({ ...this.state, locale: nextProps.locale });
      }
      /*if (this.props.path !== nextProps.path) {
        this.setState({ ...this.state, path: nextProps.path, isActive: false });
      }*/
      return;
    }

    TweenMax.to(navItems, 0.4, {
      autoAlpha: 0,
      y: `+5px`,
      ease: Quart.easeOut,
      onComplete: () => {
        this.setState({ ...this.state, locale: nextProps.locale }, () => {
          const navItems = document.querySelectorAll(
            '.navbar-end .navbar-item:not(.is-locale-switcher)'
          );
          this.setActiveItem(navItems, nextProps.path);
          TweenMax.from(navItems, 0.5, {
            autoAlpha: 0,
            y: `-5px`,
            ease: Quart.easeOut
          });
        });
      }
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.locale !== nextState.locale ||
      this.state.isActive !== nextState.isActive
    );
  }

  toggleIsActive() {
    let isActive = !this.state.isActive;
    this.setState({ ...this.state, isActive });
  }

  render() {
    const props = this.props;
    const state = this.state;

    const { nav, pageId, homeSlug } = props;
    const { locale, isActive } = state;

    const isActiveClass = isActive ? ' is-active' : '';

    return (
      <nav
        className="navbar is-white has-shadow"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <div
              className={`navbar-burger burger${isActiveClass}`}
              onClick={this.toggleIsActive.bind(this)}
              style={{ cursor: `pointer` }}
            >
              <span />
              <span />
              <span />
            </div>
            <Link
              className="navbar-item"
              to={locale === 'fr' ? `/${homeSlug}` : '/'}
            >
              <img src={logo} alt="logo" width="210" />
              {/*
              <i style={{ width: 210, height: 49 }}>
                <Logo animationDelay={5} />
              </i>
            */}
            </Link>
          </div>
          <div className={`navbar-menu${isActiveClass}`}>
            <div className="navbar-end">
              {nav.links.map(link => (
                <div key={link.id} className={`navbar-item`}>
                  <Link to={`${'/' + link.link.slug}`}>{link.label}</Link>
                </div>
              ))}
              <div
                key="localeSwitcher"
                className="navbar-item is-locale-switcher"
              >
                <LocaleSwitcher
                  pageId={pageId}
                  currentLocale={locale}
                  locales={['en', 'fr']}
                />
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}
export default MainNavigation;



// WEBPACK FOOTER //
// ./src/components/MainNavigation.js